

import React, { useState, useEffect } from "react";
import CloseIcon from "@mui/icons-material/Close";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import EditIcon from "@mui/icons-material/Edit";
import addpdf from "../../assets/tasks/addicon.svg";
import SaveIcon from "@mui/icons-material/Save";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutline";
import { Edit } from "@mui/icons-material";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import api from "../../api/api";
import dayjs from "dayjs";
import { orderTimeLabel } from "../../landingscreen/cards/visitflow";
import { bluepen } from "../../utils/svgs/svgcode";
import { tasks } from "../../customsidenav/svgslist";
import ScheduleModal from "./ScheduleModal";
import {
  isActionableOrder,
  isVisitOrder,
  visitRowValues,
} from "../../landingscreen/cards/visitrow";
import { getPracticeId } from "../../config/practice";
import { isInHouseTest } from "../inhouseTestUpload";

// A completed in-house test can be selected again: "Mark as Complete" then sends its
// result to Athena again - the gateway files a test once and answers a repeat with the
// copy already there, so this only matters when the first upload failed (review 10-06).
const canResend = (order) => order?.status === "COMPLETED" && isInHouseTest(order);
const TasksModal = ({
  closetaskModal,
  data,
  setToastSeverity,
  setToastMessage,
  setFetchedData,
  setOpenToast,
  task,
  markAsComplete,
  markAscancel,
  // handleScheduleClick,
  scheduleStates,
}) => {
  const [editingNote, setEditingNote] = useState(null); // Track the index of the note being edited
  const [newNote, setNewNote] = useState(""); // Track the text input for new or edited note
  const [selectedTasks, setSelectedTasks] = useState([]);
  const [selectAll, setSelectAll] = useState(false); // Track Check All checkbox state
  const [isCompleted, setIsCompleted] = useState(false);
  // True while a completion (and its in-house Athena uploads) runs: the button is
  // off so a second click cannot complete + upload the same tests again (10-06).
  const [completing, setCompleting] = useState(false);
  const practiseid = getPracticeId();
  const [tasksState, setTasksState] = useState([]);
  const [users, setUsers] = useState([]);
  const [scheduleConfirmationOpen, setScheduleConfirmationOpen] =
    useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  let firstName = localStorage.getItem("firstname");
  let lastName = localStorage.getItem("lastname");
  const fullName = `${firstName} ${lastName}`;

    const fetchUsersData = async () => {
      try {
        const response = await api.get(`/v1/${practiseid}/users`);
        if (response.status === 200) {
          setUsers(response.data);
        } else {
          setUsers([]);
        }
      } catch (error) {
        console.error(
          "Error fetching users:",
          error.response || error.message || error,
        );
        setUsers([]);
      } finally {
      }
    };
useEffect(() => {
  fetchUsersData();
}, []);

  const handleNoteEdit = (index) => {
    setEditingNote(index); // Set the index of the note being edited
    setNewNote(task[index].order_notes || ""); // Populate the input field with the existing note (if any)
  };

  const handleSaveNote = async (order) => {
    const noteContent = newNote; // Get the updated note content
    try {
      if (order.order_notes) {
        // Update existing note API
        await handleUpdatenoteSubmit(order, noteContent);
      } else {
        // Add new note API
        await handleaddnoteSubmit(order, noteContent);
      }
      setTasksState((prev) =>
        prev.map((t) =>
          t.id === order.id ? { ...t, order_notes: noteContent } : t
        )
      );
      order.order_notes = noteContent; // Update the note in the local state
      setEditingNote(null); // Close the editor
    } catch (error) {
      console.error("Error saving note:", error);
    }
  };

  const handleCancelNote = () => {
    setEditingNote(null); // Close the editor without saving
  };

  const closeScheduleConfirmationModal = () => {
    setScheduleConfirmationOpen(false);
    setSelectedOrder(null);
  };

  const handleScheduleClick = (order) => {
    setSelectedOrder(order); // Set the selected order for confirmation
    setScheduleConfirmationOpen(true); // Open the confirmation modal
  };

  const handleTaskSelection = (taskIndex) => {
    const updatedSelectedTasks = [...selectedTasks];
    if (updatedSelectedTasks.includes(taskIndex)) {
      updatedSelectedTasks.splice(updatedSelectedTasks.indexOf(taskIndex), 1);
    } else {
      updatedSelectedTasks.push(taskIndex);
    }
    setSelectedTasks(updatedSelectedTasks);
  };
const handleSelectAll = () => {
  if (selectAll) {
    setSelectedTasks([]);
  } else {
    const selectableTasks = task
      .filter(
        (order) =>
          isActionableOrder(order) &&
          order.status !== "COMPLETED" &&
          order.status !== "CANCELLEDTASK"
      )
      .map((order) => order.id);

    setSelectedTasks(selectableTasks);
  }
  setSelectAll(!selectAll);
};

  // const handleSelectAll = () => {
  //   if (selectAll) {
  //     setSelectedTasks([]); // Deselect all
  //   } else {
  //     const allTasks = task.map((order, index) => order.id); // Select all tasks
  //     setSelectedTasks(allTasks);
  //   }
  //   setSelectAll(!selectAll);
  // };

  // const handleCompleteAllTasks = (task) => {
  //   console.log("Selected task IDs:", selectedTasks);
  //   const selectedTaskIds = selectedTasks.map((id) => id.toString());
  //   // Convert each task ID to a string and map over the array
  //   const selectedTasksAsStrings = selectedTasks.map((task) => task.toString());
  //   setTasksState((prev) =>
  //     prev.map((t) =>
  //       selectedTaskIds.includes(t.id.toString())
  //         ? { ...t, status: "COMPLETED" }
  //         : t
  //     )
  //   );
  //   // Call markAsComplete with the array of strings
  //   markAsComplete(selectedTasksAsStrings, task);
  //   setIsCompleted(true);
  // };
 const updateResult = async (order, value) => {
  try {
    // optimistic UI update
    setTasksState((prev) =>
      prev.map((t) =>
        t.id === order.id ? { ...t, result: value } : t
      )
    );

    await api.put(`/v1/${practiseid}/orders/${data?.patientid}/update-result`, {
      id: order.id,
      result: value,
   orderdate: dayjs(order.ts).format("YYYY-MM-DD")
    });

    setToastSeverity("success");
    setToastMessage("Result updated");
    setOpenToast(true);
  } catch (err) {
    console.log(err);
    setToastSeverity("error");
    setToastMessage("Failed to update result");
    setOpenToast(true);
  }
};

  const handleCompleteAllTasks = async () => {
  if (completing) return;
  // Tasks not completed or cancelled yet - plus completed in-house tests selected on
  // purpose to resend their result (the gateway never files a test twice; an older
  // gateway is detected by markAsComplete and gets only newly completed tests).
  const validTaskIds = selectedTasks
    .map((id) => id.toString())
    .filter((id) => {
      const t = task.find((x) => String(x.id) === id);
      return !t || canResend(t) || (t.status !== "COMPLETED" && t.status !== "CANCELLEDTASK");
    });
  if (validTaskIds.length === 0) {
    setToastSeverity("info");
    setToastMessage("The selected tasks are already completed");
    setOpenToast(true);
    return;
  }

  setTasksState((prev) =>
    prev.map((t) =>
      isActionableOrder(t) &&
      validTaskIds.includes(String(t.id)) &&
      t.status !== "COMPLETED" &&
      t.status !== "CANCELLEDTASK"
        ? { ...t, status: "COMPLETED" }
        : t
    )
  );

  // Real orders only: markAsComplete takes the patient and date from the
  // first row, and the dashboard's display-only visit row has neither.
  setCompleting(true);
  try {
    await markAsComplete(validTaskIds, task.filter(isActionableOrder));
    setIsCompleted(true);
    setSelectedTasks([]);
    setSelectAll(false);
  } finally {
    setCompleting(false);
  }
};


  // const handleCancelAllTasks = (task) => {
  //   // Get the task object by index
  //   const selectedTaskIds = selectedTasks.map((id) => id.toString());
  //   setTasksState((prev) =>
  //     prev.map((t) =>
  //       selectedTaskIds.includes(t.id.toString())
  //         ? { ...t, status: "CANCELLEDTASK" }
  //         : t
  //     )
  //   );
  //   markAscancel(
  //     selectedTasks.map((task) => task.toString()),
  //     task
  //   ); // Call markAscancel for each task
  // };
const handleCancelAllTasks = () => {
  // never a completed task (a completed in-house test can be selected to resend it)
  const validTaskIds = selectedTasks
    .map((id) => id.toString())
    .filter((id) => {
      const t = task.find((x) => String(x.id) === id);
      return !t || (t.status !== "COMPLETED" && t.status !== "CANCELLEDTASK");
    });
  if (validTaskIds.length === 0) {
    setToastSeverity("info");
    setToastMessage("The selected tasks are already completed");
    setOpenToast(true);
    return;
  }

  setTasksState((prev) =>
    prev.map((t) =>
      isActionableOrder(t) &&
      validTaskIds.includes(String(t.id)) &&
      t.status !== "COMPLETED" &&
      t.status !== "CANCELLEDTASK"
        ? { ...t, status: "CANCELLEDTASK" }
        : t
    )
  );

  markAscancel(validTaskIds, task.filter(isActionableOrder));
};

  let user = localStorage.getItem("user");

  const handleconfirmScheduleClick = async (order) => {
    try {
      // Create the payload to send the status update
      const newStatusFlag = selectedOrder.schedule === "t" ? "f" : "t"; // Toggle status for this specific order

      console.log(newStatusFlag);

      // Update the local tasksState to reflect the schedule change immediately
      setTasksState((prev) =>
        prev.map((t) =>
          t.id === order.id ? { ...t, schedule: newStatusFlag } : t
        )
      );

      // Create the payload to send the status update
      const payload = {
        orderid: order.id,
        statusflag: newStatusFlag,
        login_user: user, // You can replace with the actual logged-in user
      };

      // Call API to update status flag
      const response = await api.put(
        `/v1/${practiseid}/tasks/update_status_schedule`,
        payload
      );

      if (response.status === 200) {
        setToastSeverity("success");
        setToastMessage("Schedule updated successfully");
        setOpenToast(true);
        // If the update was successful, refresh data if necessary
        // You might want to call a refresh function here if available
      } else {
        setToastSeverity("info");
        setToastMessage(response.message || "Error updating schedule");
        setOpenToast(true);
        console.error("Error updating status");
        // Revert the local state change if API call failed
        setTasksState((prev) =>
          prev.map((t) =>
            t.id === order.id ? { ...t, schedule: selectedOrder.schedule } : t
          )
        );
      }
    } catch (error) {
      setToastSeverity("error");
      setToastMessage("Something Went Wrong");
      setOpenToast(true);
      console.error("Error updating status:", error);
      // Revert the local state change if API call failed
      setTasksState((prev) =>
        prev.map((t) =>
          t.id === order.id ? { ...t, schedule: selectedOrder.schedule } : t
        )
      );
    }
  };

  const handleUpdatenoteSubmit = async (order, noteContent) => {
    try {
      const response = await api.put(
        `/v1/${practiseid}/tasks/update_task_notes`,
        {
          orderid: order.id, // Assuming task has an 'id' field, you can adjust if it's named differently
          tasknotes: noteContent,
          loginuser: user, // You may want to get the logged-in user's info dynamically
        }
      );

      console.log("Note added successfully:", response.data);
      if (response.status == 200) {
        setToastSeverity("success");
        setToastMessage(response.message);
        setOpenToast(true);
      } else {
        setToastSeverity("info");
        setToastMessage(response.message);
        setOpenToast(true);
      }
      // Close modal on successful submission
    } catch (error) {
      setToastSeverity("error");
      setToastMessage("Something Went Wrong");
      setOpenToast(true);
      console.error("Error adding note:", error);
    }
  };

  const handleaddnoteSubmit = async (order, noteContent) => {
    try {
      const response = await api.put(
        `/v1/${practiseid}/tasks/update_task_notes`,
        {
          orderid: order.id, // Assuming task has an 'id' field, you can adjust if it's named differently
          tasknotes: noteContent,
          loginuser: user, // You may want to get the logged-in user's info dynamically
        }
      );
      if (response.status == 200) {
        setToastSeverity("success");
        setToastMessage(response.message);
        setOpenToast(true);
      } else {
        setToastSeverity("info");
        setToastMessage(response.message);
        setOpenToast(true);
      }
      console.log("Note added successfully:", response.data);
    } catch (error) {
      setToastSeverity("error");
      setToastMessage("Something Went Wrong");
      setOpenToast(true);
      console.error("Error adding note:", error);
    }
  };
useEffect(() => {
  const selectableCount = task.filter(
    (order) =>
      isActionableOrder(order) &&
      order.status !== "COMPLETED" &&
      order.status !== "CANCELLEDTASK"
  ).length;

  const selectedOpen = selectedTasks.filter((id) =>
    task.some(
      (order) =>
        order.id === id &&
        order.status !== "COMPLETED" &&
        order.status !== "CANCELLEDTASK"
    )
  ).length;
  setSelectAll(selectableCount > 0 && selectedOpen === selectableCount);
}, [selectedTasks, task]);

  // useEffect(() => {
  //   // Update selectAll state based on selectedTasks length
  //   setSelectAll(selectedTasks.length === task.length);
  // }, [selectedTasks, task.length]);
  useEffect(() => {
    setTasksState(task);
  }, [task]);

  // The dashboard's display-only visit row (level of visit, no VISIT order)
  // is listed but never selectable or actionable.
  const allTasksCompletedOrCancelled = task
    .filter(isActionableOrder)
    .every(
      (order) =>
        order.status === "COMPLETED" || order.status === "CANCELLEDTASK"
    );
  // completed in-house tests stay actionable: their result can be sent to Athena again
  const anyResendable = task.some((order) => isActionableOrder(order) && canResend(order));
  const resendOnly =
    allTasksCompletedOrCancelled ||
    (selectedTasks.length > 0 &&
      selectedTasks.every((id) => canResend(task.find((order) => order.id === id))));

  return (
    <div
      className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50"
      onClick={() => {
        typeof setFetchedData === "function" &&
          setFetchedData((prevData) =>
            prevData.map((item) =>
              item.id === data?.id ? { ...item, orders: tasksState } : item
            )
          );
        console.log("cdd");
        closetaskModal();
      }} // Close modal on clicking outside
    >
      <div
        className="bg-white  rounded-xl w-[90%] relative flex flex-column"
        onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the modal
      >
        <div className="flex px-4 py-3 justify-between w-full flex-col sm:flex-row md:flex-row lg:flex-row items-center border-b">
          <h2 className="text-lg font-semibold">
            Quick View Tasks ({task.length}){" "}
          </h2>
          <div className="flex items-center gap-3">
            {(!allTasksCompletedOrCancelled || anyResendable) && (
              <>
                {!allTasksCompletedOrCancelled && (
                <button
                  onClick={() => {
                    if (selectedTasks.length == 0) {
                      setToastSeverity("info");
                      setToastMessage("Please Select Task to Cancel");
                      setOpenToast(true);
                      return;
                    }
                    handleCancelAllTasks(task);
                  }}
                  className="p-2 px-4 font-semibold rounded-xl border bg-[#FEE2E2] border-gray-300 text-[#F44336]"
                >
                  Cancel Task
                </button>
                )}
                <button
                  onClick={() => {
                    if (selectedTasks.length == 0) {
                      setToastSeverity("info");
                      setToastMessage("Please Select Task to Mark as Complete");
                      setOpenToast(true);
                      return;
                    }
                    handleCompleteAllTasks(task);
                  }}
                  disabled={completing}
                  aria-busy={completing}
                  className={`p-2 px-4 font-semibold rounded-xl border text-[#059669] ${
                    isCompleted ? "bg-[#A7F3D0]" : "bg-[#D1FAE5]"
                  } border-gray-300 ${completing ? "opacity-60 cursor-wait" : ""}`}
                >
                  {completing
                    ? "Completing…"
                    : resendOnly
                      ? "Send to Athena again"
                      : isCompleted
                        ? "Completed ✔"
                        : "Mark as Complete"}
                </button>
              </>
            )}
            <button
              onClick={() => {
                typeof setFetchedData === "function" &&
                  setFetchedData((prevData) =>
                    prevData.map((item) =>
                      item.id === data?.id
                        ? { ...item, orders: tasksState }
                        : item
                    )
                  );

                closetaskModal();
              }}
              className="p-2 rounded-full"
            >
              <CloseIcon style={{ color: "#C7C7CB" }} />
            </button>
          </div>
        </div>

        <div className="py-4 px-4 border-b items-start w-full flex-col sm:flex-row md:flex-row lg:flex-row ">
          <div className="flex gap-2 items-center">
            <input
              type="checkbox"
              className="mr-2 w-4 h-4"
              checked={selectAll}
              onChange={handleSelectAll}
            />
            <div className="text-sm text-[#4B5563] ">CHECK ALL</div>
          </div>
        </div>

        <div
          className="mb-4 max-h-[350px] w-auto overflow-y-auto"
          style={{ scrollbarWidth: "none" }}
        >
          {/* Header Row */}
          {/* <div className="grid grid-cols-12 gap-4 px-4 py-2 bg-gray-50 border-b font-semibold text-sm text-gray-600">
            <div className="col-span-1">Select</div>
            <div className="col-span-4">Task Details</div>
            <div className="col-span-2">Schedule</div>
            <div className="col-span-2">Status</div>
            <div className="col-span-3">Notes</div>
          </div> */}

          {task.map((order, index) => (
            <div key={index} className="border-b text-start">
              <div className="grid grid-cols-12 gap-4 p-4 items-center">
                {/* Select/Status Column */}
                <div className="col-span-1 flex justify-center">
                  {!isActionableOrder(order) ? null : order.status === "COMPLETED" ||
                  order.status === "CANCELLEDTASK" ? (
                    <div className="flex items-center gap-1">
                    {canResend(order) && (
                      <input
                        type="checkbox"
                        className="w-4 h-4"
                        aria-label={`Select ${order.ordername} to send its result to Athena again`}
                        title="Select, then Mark as Complete, to send this result to Athena again (a copy already in Athena is not sent twice)"
                        checked={selectedTasks.includes(order.id)}
                        onChange={() => handleTaskSelection(order.id)}
                      />
                    )}
                    <div
                      className={`text-xs px-3 py-1 rounded-full whitespace-nowrap ${
                        order.status === "COMPLETED"
                          ? "bg-[#DCFCE7] text-[#15803D]"
                          : "bg-[#FEE2E2] text-[#DC2626]"
                      }`}
                    >
                      {order?.completed_by
                        ? order.completed_by.charAt(0).toUpperCase() +
                          order.completed_by.slice(1).toLowerCase()
                        : "N/A"}
                    </div>
                    </div>
                  ) : (
                    <input
                      type="checkbox"
                      className="w-4 h-4"
                      checked={selectedTasks.includes(order.id)}
                      onChange={() => handleTaskSelection(order.id)}
                    />
                  )}
                </div>

                {/* Task Details Column */}
                <div className="col-span-4">
                  <div className="flex flex-col gap-1 text-center">
                    <div className="text-sm font-inter text-[16px] text-black">
                      {isVisitOrder(order) && visitRowValues(order).length
                        ? visitRowValues(order).map((v) => (
                            <div key={v.slot}>
                              {`Visit · ${v.value}`}
                              {v.source && (
                                <span
                                  title={v.source.title}
                                  className={`ml-2 px-1.5 rounded-md border text-[11px] font-semibold align-middle ${
                                    v.source.kind === "ai"
                                      ? "bg-[#e8eefb] text-[#2f5a9a] border-[#d2ddf4]"
                                      : "bg-[#e5f5eb] text-[#23734a] border-[#cde8d7]"
                                  }`}
                                >
                                  {v.source.text}
                                </span>
                              )}
                            </div>
                          ))
                        : order.ordername && order.ordername.trim() !== ""
                        ? order.ordername.replace(/<[^>]*>/g, "")
                        : `${order.tov} Level - ${order.lov}`}
                    </div>
                    {!isActionableOrder(order) ? (
                      <p className="text-xs font-inter text-[#6B7280] m-0 font-light">
                        Level of visit only, no visit order
                      </p>
                    ) : (
                    <div className="text-xs font-inter text-[#4B4B4B]">
                      <p className="text-xs text-[#4B4B4B] m-0 font-light">
                      Ordered by: {
                        order.provider_name || (
                        users.length > 0
                          ? users.find(user => user.username === order.provider)
                            ? `${users.find(user => user.username === order.provider)?.firstname} ${users.find(user => user.username === order.provider)?.lastname}`
                            : order.provider
                          : order.provider
                        )
                      }
                      </p>                      
                      <p className="text-xs font-inter text-[#4B4B4B] m-0 font-light">
                        {orderTimeLabel(order, { hourPad: true })}
                      </p>
                    </div>
                    )}
                  </div>
                </div>

                {/* Schedule Column */}
                <div className="col-span-1 flex justify-center">
                  {isActionableOrder(order) && (
                  <button
                    onClick={() => handleScheduleClick(order)}
                 className={`px-3 py-1   rounded-full text-sm shadow-md border-[1.5px] flex items-center gap-1
      ${
        (tasksState.find((t) => t.id === order.id)?.schedule ||
          order?.schedule) === "t"
          ? " bg-[#E17954]  text-white "
          : " bg-[#16A34A]  text-white border-gray-200"
      }
    `}
          //  bg-[#E5E7EB]
                    disabled={
                      order?.status === "COMPLETED" ||
                      order?.status === "CANCELLEDTASK" ||
                      order?.ordertype == "VISIT" ||
                      order?.ordertype == "mrecord" ||
                      order?.ordertype == "Schedule-RTO" ||
                      order?.ordertype == "Notes" ||
                      order?.ordertype == "Referrals"
                    }
                  >
                    <span>
                      {scheduleStates[order.id] ||
                      (tasksState.find((t) => t.id === order.id)?.schedule ||
                        order?.schedule) === "t"
                        ? "Schedule"
                        : "Today"}
                    </span>
                    {order?.status === "COMPLETED" ||
                    order?.status === "CANCELLEDTASK" ||
                    order?.ordertype == "VISIT" ||
                    order?.ordertype == "mrecord" ||
                    order?.ordertype == "Schedule-RTO" ||
                    order?.ordertype == "Notes" ||
                    order?.ordertype == "Referrals" ? null : (
                      <KeyboardArrowDownIcon style={{ width: "18px" }} />
                    )}
                  </button>
                  )}
                </div>

                {/* Status Column */}
                <div className="col-span-2 flex justify-center">
                  {isActionableOrder(order) && (
                  <div
                    className={`px-3 py-2 rounded-full text-xs font-semibold flex items-center gap-1 whitespace-nowrap
    ${
      order?.status?.toLowerCase() === "created"
        ? "bg-[#EFF6FF] text-[#1D4ED8]"
        : order.status === "CANCELLEDTASK"
        ? "bg-[#FEE2E2] text-[#DC2626]"
        : "bg-[#F0FDF4] text-[#15803D]"
    }`}
                  >
                    <CheckCircleOutlineIcon
                      style={{
                        color:
                          typeof order?.status === "string" && order?.status?.toLowerCase() === "created"
                            ? "#1D4ED8"
                            : order?.status === "CANCELLEDTASK"
                            ? "#DC2626"
                            : "#15803D",
                        width: "15px",
                      }}
                    />
                    {order?.status === "CANCELLEDTASK"
                      ? "Cancelled"
                      : typeof order?.status === "string"
                      ? order.status.charAt(0).toUpperCase() + order.status.slice(1).toLowerCase()
                      : "Created"}
                  </div>
                  )}
                </div>
             {/* {(order.ordertype === "Diagnostic Tests" ||order.ordertype === "Diagnostic test")&& (
  <div className="col-span-2 flex justify-center">
    <select
      className="border rounded-md px-2 py-1 text-sm"
      value={
        tasksState.find((t) => t.id === order.id)?.result || ""
      }
      disabled={
        order.status === "COMPLETED" ||
        order.status === "CANCELLEDTASK"
      }
      onChange={(e) => updateResult(order, e.target.value)}
    >
      <option value="">Select Result</option>
      <option value="Positive">Positive</option>
      <option value="Negative">Negative</option>
      <option value="Inconclusive">Inconclusive</option>
    </select>
  </div>
)} */}
{isActionableOrder(order) && ["FLU TEST", "STREP TEST", "COVID TEST"].includes(
  order?.ordername?.toUpperCase().replace(/[-_]/g, " ").trim()
) && (
  <div className="col-span-2 flex justify-center">
    <select
      className="border rounded-md px-2 py-1 text-sm"
      value={tasksState.find((t) => t.id === order.id)?.result || ""}
      disabled={
        order.status === "COMPLETED" ||
        order.status === "CANCELLEDTASK"
      }
      onChange={(e) => updateResult(order, e.target.value)}
    >
      <option value="">Select Result</option>
      <option value="Positive">Positive</option>
      <option value="Negative">Negative</option>
      <option value="Inconclusive">Inconclusive</option>
    </select>
  </div>
)}

                {/* Notes Column */}
                <div className="col-span-2 flex justify-end">
                  {!isActionableOrder(order) ? null : order.order_notes && editingNote !== index ? (
                    <div className="relative w-full bg-[#EFF6FF] p-2 group">
                      <div className="flex justify-between items-center">
                        <div className="text-xs text-left text-[#2563EB] flex items-center">
                          <ChatBubbleOutlineIcon
                            style={{
                              width: "10px",
                              marginRight: "4px",
                              color: "#2563EB",
                            }}
                          />
                          Note
                        </div>
                        <div
                          className="opacity-0 group-hover:opacity-100 transition duration-200 cursor-pointer"
                          onClick={() => handleNoteEdit(index)}
                        >
                          {bluepen}
                        </div>
                      </div>
                      <p className="text-sm px-2 text-left truncate">
                        {order.order_notes}
                      </p>
                    </div>
                  ) : editingNote === index ? (
                    <div className="w-full flex flex-col bg-gray-60 p-2 rounded">
                      <textarea
                        rows={2}
                        value={newNote}
                        placeholder="Enter Your Note Here..."
                        onChange={(e) => setNewNote(e.target.value)}
                        className="w-full border-2 p-2 border-gray-300 rounded-md"
                      />
                      <div className="flex gap-2 justify-end mt-2">
                        <button
                          onClick={handleCancelNote}
                          className="px-2 py-1 text-xs text-[black] rounded-md"
                        >
                          Cancel
                        </button>
                        <button
                          onClick={() => handleSaveNote(order)}
                          className="px-2 bg-[black] text-xs text-[white] rounded-md"
                        >
                          <SaveIcon style={{ width: "14px" }} /> Save
                        </button>
                      </div>
                    </div>
                  ) : (
                    !order.notes && (
                      <div className="flex justify-center">
                        <img
                          src={addpdf}
                          className="w-8 h-8 cursor-pointer"
                          alt="Add PDF"
                          onClick={() => handleNoteEdit(index)}
                        />
                      </div>
                    )
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Schedule Modal */}
      <ScheduleModal
        open={scheduleConfirmationOpen}
        onClose={closeScheduleConfirmationModal}
        onConfirm={handleconfirmScheduleClick}
        order={selectedOrder}
      />
    </div>
  );
};

export default TasksModal;
